export const menuItems = [
  {
    label: 'Masters',
    path: '/masters',
    suOnly: true,
    submenu: [
      { label: 'Func Area', path: '/masters/functionarea' },
      { label: 'Trng Course', path: '/masters/trngcourse' },
      { label: 'Faculty', path: '/masters/faculty' },
      { label: 'Course Faculty', path: '/masters/coursefaculty' },
      { label: 'User', path: '/masters/user' },
      { label: 'Batch Status', path: '/masters/batchstatus' },
    ],
  },
  {
    label: 'Training',
    path: '/training',
    submenu: [
      { label: 'Schedule Planner', path: '/training/scheduleplanner' },
      { label: 'Needs Ident', path: '/training/needsident' },
      { label: 'Announcement', path: '/training/announcement' },
      { label: 'Attendance', path: '/training/attendance' },
    ],
  },
  {
    label: 'Reports',
    path: '/reports',
  },
  {
    label: 'Logout',
    path: '/',
  },
];

export const getMenuItems = (roleCode) =>
  roleCode === 'SU' ? menuItems : menuItems.filter((item) => !item.suOnly);
